export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/rawpixel-com-8c60b7650a54d7ec26946abe5c2a3eb7.jpg";